import { View } from "./View";

export interface IFileUploadProps {
  name: string;
  accept?: string[];
  arrayFieldName?: string;
  arrayFieldIndex?: string;
  label?: string;
  buttonLabel?: string;
  infoIconText?: string;
  labelTitle?: string;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  showSkeleton?: boolean;

  // multiple file handling
  allowMultiple?: boolean;

  // error display
  invalid?: boolean;
  invalidText?: string;

  // controlled form props
  value?: string | number | null;
  onChange?: (value: any) => void;
}

export const FileUpload = (props: IFileUploadProps) => {
  return <View {...props} />;
};
